// extracted by mini-css-extract-plugin
export default {"tariff":"Tariff__tariff___q4RQd","default":"Tariff__default___vbz5I","current":"Tariff__current___TbAjz","special":"Tariff__special___JI_hU","image":"Tariff__image___EvAmy"};